<template>
  <div class="patient-upload">

    <md-toolbar class="md-primary nav-style first-nav">
      <img src="../assets/logo.png" class="logo_navbar">
      <div class="md-toolbar-section-end nav-style">
        <md-button class="user-mail" @click="showLogoutOptions = true">
          <i class="material-icons person-icon">person</i>
          <div class="user-mail-text">{{ user }}</div>
        </md-button>
        <md-drawer class="md-right" :md-active.sync="showLogoutOptions">
          <md-list>
            <md-list-item>
              <md-button class="md-raised md-accent" :md-ripple="false" @click="logout()" s>Disconnetti</md-button>
            </md-list-item>
          </md-list>
        </md-drawer>
      </div>
    </md-toolbar>
    <div class="md-title second-navbar">COMUNICAZIONE SICURA</div>
    <form id="app" @submit.prevent="submitUpload" class="card-doc-upload">

      <md-card md-with-hover v-if="uploadFileSpinner">
        <md-card-content>
          <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
        </md-card-content>
      </md-card>


    <md-card md-with-hover v-if="!uploadFileSpinner">


      <md-card-content>
        <div class="md-title title-style">Risposta al Servizio Clienti Humanitas</div>
        <div class="md-subhead"></div>
        <md-field :class="messageClass" md-clearable>
          <label for="mailSubject">Oggetto della mail</label>
          <md-input v-model="mailSubject" name="mailSubject" type="text" id="mailSubject" value="mailSubject"></md-input>
          <span class="md-error" >Completare il campo per poter proseguire</span>
        </md-field>
        <md-field md-clearable>
          <label>Inserisci qui il messaggio da inviare al dottore</label>
          <md-textarea v-model="textarea" md-counter="200"></md-textarea>
        </md-field>
        <md-field>
          <label>Carica qui uno o più file</label>
          <md-file v-model="multiple" multiple type="file" value="upload" accept=".pdf" @change="storePDF($event)" name="file" id="files" />
          <span >Solo pdf di max 25MB</span>
          <span class="md-error" v-if="isEmpty">Caricare uno o più file per poter proseguire</span>
        </md-field>
        <br />
        <md-button class="md-raised md-accent" :md-ripple="false" type="submit" @submit="submitUpload()" :disabled="multiple == null" value="Submit">Invia</md-button>
      </md-card-content>
    </md-card>
    </form>
  </div>
</template>

<script>
  import firebase from 'firebase/app'
  import 'firebase/firestore'
  import 'firebase/auth'
  import parsley from 'parsleyjs'
  import $ from 'jquery'
  import axios from 'axios'



  import {
    LoginChecker
  } from '@/utils/login-check'

  export default {
    name: 'PatientUpload',
    data() {
      return {
        name: null,
        surname: null,
        primaryMail: null,
        secondaryMail: null,
        patientPhNo: null,
        mailSubject: 'Oggetto Comunicazione',
        patientBirthDate: null,
        isEmpty: false,
        textarea: 'Salve, \nLe invio i allegato i documenti',
        multiple: null,
        file: null,
        idsFileDrive: [],
        fileName: null,
        user: null,
        showLogoutOptions: false,
        userPhone: null,
        tooHumanitas: true,
        uploadFileSpinner: true
      }
    },
    computed: {
      messageClass() {
        if (!this.multiple) {
          return {
            'md-invalid': this.isEmpty
          }
        } else {
          return true
        }
      }
    },
    mounted: function() {
      //console.log(this.$route.query.ref)
        // controllo esistenza stringa in firestorage
        // controllo auth


            var user = firebase.auth().currentUser
            console.log(user)
            if (user) {
              // da mettere ciclo per controllare se + providerData
              if (user.providerData[0].providerId == 'phone') {
                console.log('Phone-Authenticated user')
                this.uploadFileSpinner = false
                //check utente codice
                //get file URL
              } else {
                this.$store.commit('setRedirectPath', this.$route.fullPath)
                console.log('User not Phone-Authenticated')
                this.$router.push('/phone-auth')
              }
            } else {
              console.log('User not Authenticated')
              this.$store.commit('setRedirectPath', this.$route.fullPath)
              this.$router.push('/phone-auth')
            }
            //console.log(this.$store.state.detailName, this.$store.state.detailSurname, this.$store.state.detailPrimaryMail, this.$store.state.detailPhone)



    },
    methods: {
      logout: function() {
        var self = this
        firebase.auth().signOut().then(function() {
          self.$router.push({
            path: '/logout'
          })
        })
      },
      validateEmailAddress: function(email) {
        var re = /^[\w]+([\.\w\-\+\_])*@[\w]+([\.\w\-\+\_])*\.+[a-zA-Z]{2,}$/;
        return re.test(String(email).toLowerCase());
      },
      validatePhoneNumber: function(phoneNumber){
            var re = /^\+[0-9]*$/;
            return re.test(String(phoneNumber))
      },
      validateBirthDate: function(birthDate){
        var re = /^((\d{2})\/(\d{2})\/(\d{4}))$/
        return re.test(String(birthDate))
      },
      storePDF: function(e) {
        this.file = e.target.files
      },
      upload2Storage: function(fbBucketName, file) {

        //console.log(file)
        var self = this
        // create a storage ref
        var storageRef = firebase.storage().ref(`${fbBucketName}/${self.$store.state.detailPrimaryMail}/${file.name}`);
        // upload file
        var uploadTask = storageRef.put(file);
        // update progress bar
        uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
          function(snapshot) {
            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
            var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            console.log('Upload is ' + progress + '% done');
            switch (snapshot.state) {
              case firebase.storage.TaskState.PAUSED: // or 'paused'
                console.log('Upload is paused');
                break;
              case firebase.storage.TaskState.RUNNING: // or 'running'
                console.log('Upload is running');
                break;
            }

          },
          function(error) {
            // A full list of error codes is available at
            // https://firebase.google.com/docs/storage/web/handle-errors
            switch (error.code) {
              case 'storage/unauthorized':
                // User doesn't have permission to access the object
                break;
              case 'storage/canceled':
                // User canceled the upload
                break;
              case 'storage/unknown':
                // Unknown error occurred, inspect error.serverResponse
                break;
            }
          },
          function() {

              uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
                self.downloadURL = downloadURL
                var updateToHumanitasCollection = self.updateToHumanitasCollectionHumanitas(downloadURL, file.name)

              })





          })

      },
      // Upload to Shared Drive
      // upload2TD: function(i) {
      //   var self = this
      //   let formData = new FormData();
      //   self.fileName = self.file[i].name
      //   formData.append('file', self.file[i]);
      //   formData.append('patientMail', this.$store.state.detailPrimaryMail)
      //
      //
      //   axios.post('/upload2TD',
      //       formData, {
      //         headers: {
      //           'Content-Type': 'multipart/form-data',
      //           'Access-Control-Allow-Origin': '*',
      //           'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
      //           'Access-Control-Allow-Methods': 'POST'
      //         }
      //       }
      //     ).then(function(data) {
      //
      //       console.log('SUCCESS!!');
      //       self.idsFileDrive.push(data.data.data['connections'])
      //
      //
      //       var updateToHumanitasCollection = self.updateToHumanitasCollectionHumanitas(data.data.data['connections'])
      //       i = i+1
      //       if (i < self.file.length){
      //         self.upload2TD(i)
      //
      //       } else if (i == self.file.length){
      //         self.sendMail2Doc()
      //       }
      //
      //     }).catch(function() {
      //       console.log('FAILURE!!');
      //     });
      //
      //
      //
      // },
      checkLogin: function() {
        var self = this
        var currentUser = firebase.auth().currentUser
        if (!currentUser) {
          self.$router.push({
            path: '/'
          })
        }
        // else if (status.isLogin && !status.isGoogle) {
        //   firebase.auth().signOut().then(() => {
        //     self.$router.push({
        //       path: '/unauthorized'
        //     })
        //   })
        // }
        else {
          self.show = true
          self.user = currentUser.email
        }
      },
      sendMail2Doc: function() {
        var self = this
        axios.post('/mailToDoc', {
          "emailSubject": self.mailSubject,
          "emailBody": self.textarea,
          //"url": self.idsFileDrive,
          "url": ['ciao', 'piccola', 'joy'],
          "staffMail": "admin@demo.goreply.io",
          "userMail": self.$store.state.detailPrimaryMail
        }, {
          headers: {
            //Authorization: 'Bearer ' + idToken
          }
        }).then(function(response) {
          console.log("Email sent")
          console.log(self)
          self.uploadFileSpinner = false
          self.$router.push({path: '/act-options'})
          return true
        }).catch(function(error) {
          self.uploadFileSpinner = false
          console.log('Error sending mail ' + error)
          //console.error('/getContacts ERROR: ' + error)
          self.$notify({
            group: 'foo',
            title: 'Ci spiace, si è verificato un errore durante l\'invio della mail, prego riprovare',
            text: error,
            duration: 300,
            max:1
          })
        })
      },
      updateToHumanitasCollectionHumanitas: function(downloadURL, nomeFile){
        //console.log(document.getElementById("mailSubject").value)
        var self = this
          axios.post('/updateHistory',
              {
                "fileName": 'teeeest',
                "patientMail": self.$store.state.detailPrimaryMail,
                "patientName": self.$store.state.detailName,
                "patientSurname": self.$store.state.detailSurname,
                "downloadUrl": downloadURL,
                "collectionName": 'toHumanitas',
                "from": 'new patient',
                "communicationSubj":   'subject',
                "communicationMess": 'messaggio'
              },
              {
                headers: {
                  //Authorization: 'Bearer ' + idToken
                }
              }
            ).then(function() {
              console.log('toHumanitas history updated');
            })
            .catch(function() {
              console.log('toHumaitas history update failed');
            });
       },
      submitUpload: function() {
        var self = this
        if (!self.file) {
          self.uploadFileSpinner = false
          return {
            'md-invalid': self.isEmpty
          }
        } else {

          if (!self.validateEmailAddress(this.$store.state.detailPrimaryMail)){
            self.uploadFileSpinner = false
            self.$notify({
              group: 'foo',
              title: 'Prego inserire un indirizzo email valido',
              text: 'Il formato inserito non è valido',
              duration: 300,
            })
          } else if (!self.validatePhoneNumber(this.$store.state.detailPhone)) {
            self.uploadFileSpinner = false
            self.$notify({
              group: 'foo',
              title: 'Prego inserire un numero di telefono valido',
              text: 'Il formato inserito non è valido',
              duration: 300,
            })
          }
          else {
            console.log("file array len: " + self.file.length)
            self.$store.commit('patientsToClinic')
            var fbBucketName = 'receivedFiles'
            //var index = 0
            self.uploadFileSpinner = true
            //var recursiveUpload = self.upload2TD(index)
            for (var i = 0; i < self.file.length; i++) {
              var file = self.file[i]
              self.fileName = file.name;
              var upStorage = self.upload2Storage(fbBucketName, file)

            }
             var sedMailToPatient = self.sendMail2Doc()

          }
        }
      },
    }
  }
</script>

<style scoped>
  /* "scoped" attribute limit the CSS to this component only */
  .logo_navbar {
    text-align: center;
    height: 40px;
    padding: 3px;
  }


  .logout {
    margin-top: 40px;
  }

  .home-button {
    width: 487px;
  }

  .md-card {
    width: 60%;
    margin: 4px;
    display: inline-block;
    vertical-align: center;
  }

  .first-nav {
    background-color: #FFFFFF !important;
  }

  .nav-style {
    height: 50px;
  }

  .second-navbar {
    background-color: #027953;
    font-size: 26px;
    font-weight: bold;
    color: #FFFFFF;
    padding: 1.3%
  }

  .title-style {
    color: #027953;
  }

  .text-card {
    text-align: right;
    color: grey;
  }



  .user-mail {
    border-radius: 22px;
    background-color:  #F2F1F2;

  }


  .person-icon {
    color: #027953;
  }

  .simple-text {
    color: black;
    font-size: 17px;
  }

  .button-text {

    padding-top:6%;
    padding-left: 1%;
    float:right;
  }

  .icon-style {
    font-size: 50px;

    color: #027953;
    -webkit-border-radius: 22px;

  }
</style>



// WEBPACK FOOTER //
// src/components/PatientUpload.vue